
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"main-content\" class=\"card\">\n    <header>\n      <h1 id=\"fxa-sign-in-reported-header\">{{#t}}Thank you for your vigilance{{/t}}</h1>\n    </header>\n\n    <section>\n      <p>\n        {{#t}}Our team has been notified. Reports like this help us fend off intruders.{{/t}}\n      </p>\n    </section>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  